import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const tipoDeFiscalizacao_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TipoFiscalizacao")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetSituacoes: (tipoFiscalizacao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoFiscalizacao/GetSituacoes/${tipoFiscalizacao_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListApp: (id = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TipoFiscalizacao/GetListApp/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListAtivos: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoFiscalizacao/GetListAtivos`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoFiscalizacao/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("TipoFiscalizacao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("TipoFiscalizacao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postTipoFiscalizacaoServicos: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("TipoFiscalizacao/PostTipoFiscalizacaoServicos", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putTipoFiscalizacaoServicos: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("TipoFiscalizacao/PutTipoFiscalizacaoServicos", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    DeleteTipoFiscalizacaoServicos: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`TipoFiscalizacao/DeleteTipoFiscalizacaoServicos/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postTipoFiscalizacaoOrigem: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("TipoFiscalizacao/PostTipoFiscalizacaoOrigem", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putTipoFiscalizacaoOrigem: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("TipoFiscalizacao/PutTipoFiscalizacaoOrigem", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    DeleteTipoFiscalizacaoOrigem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`TipoFiscalizacao/DeleteTipoFiscalizacaoOrigem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default tipoDeFiscalizacao_api;
